<template>
  <div>
    <PrimaryButton @click.native="openDialog" light shrink>
      Edit
      <v-icon class="ml-3">mdi-pencil</v-icon>
    </PrimaryButton>
    <EditOfferDialog
      @close="closeDialog"
      :isOpen="isOpen"
      :currentOffer="currentOffer"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditOfferDialog from "@/views/offers/dialogs/EditOfferDialog";

export default {
  props: {
    currentOffer: {
      type: Object,
      required: true
    }
  },
  components: {
    PrimaryButton,
    EditOfferDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
